import { render, staticRenderFns } from "./moving-board.vue?vue&type=template&id=ecdef8ac&scoped=true&"
import script from "./moving-board.vue?vue&type=script&lang=js&"
export * from "./moving-board.vue?vue&type=script&lang=js&"
import style0 from "./moving-board.vue?vue&type=style&index=0&id=ecdef8ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdef8ac",
  null
  
)

export default component.exports